import { createSlice } from '@reduxjs/toolkit';
import { currentStoreChanged, sessionCleared } from '@/shared/lib/redux/actions';

const STORAGE_KEY = 'currentStoreId';

export interface StoreState {
  currentStoreId: string | null;
}

const initialState: StoreState = {
  currentStoreId: localStorage.getItem(STORAGE_KEY),
};

const storeSlice = createSlice({
  name: 'store',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(currentStoreChanged, (state, action) => {
        state.currentStoreId = action.payload;
        if (action.payload) localStorage.setItem(STORAGE_KEY, action.payload);
        else localStorage.removeItem(STORAGE_KEY);
      })
      .addCase(sessionCleared, (state) => {
        state.currentStoreId = null;
        localStorage.removeItem(STORAGE_KEY);
      });
  },
});

export const storeReducer = storeSlice.reducer;
